









import { Vue, Component, Prop } from 'vue-property-decorator';
import { Notification as Notif } from '@compassdigital/foodworks.ts.sdk';

import Notification from '@/components/NotificationPane/Notification/index.vue';

@Component({
  components: {
    Notification,
  },
})
export default class NotificationList extends Vue {
  @Prop({}) notifications!: Array<Notif>;
}
